import React from 'react';

export default () => (
  <svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.9 19H2.1C1.54305 19 1.0089 18.7761 0.615076 18.3776C0.221249 17.9791 0 17.4386 0 16.875V4.125C0 3.56141 0.221249 3.02091 0.615076 2.6224C1.0089 2.22388 1.54305 2 2.1 2H18.9C19.457 2 19.9911 2.22388 20.3849 2.6224C20.7787 3.02091 21 3.56141 21 4.125V16.875C21 17.4386 20.7787 17.9791 20.3849 18.3776C19.9911 18.7761 19.457 19 18.9 19ZM3.15 11.5625V13.6875H14.7V11.5625H3.15ZM3.15 7.3125V9.4375H17.85V7.3125H3.15Z" fill="currentColor" />
  </svg>
);
